export default __webpack_public_path__ + "static/media/box-of-icons.8b5ad1c9.png";